import { authRoleAccess } from "auth/AuthRoleAccess";
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import KitchenIcon from '@mui/icons-material/Kitchen';

export const navigationItems = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: <GridViewOutlinedIcon />,
    roles: authRoleAccess.dashborad,
  },
  {
    title: 'Restaurant Menu',
    path: '/restaurant-menu',
    icon: <RestaurantMenuIcon />,
    roles: authRoleAccess.dashborad,
  },
  {
    title: 'Kitchen Display',
    path: '/kds',
    icon: <KitchenIcon />,
    roles: authRoleAccess.dashborad,
  },
  {
    title: 'Settings',
    path: '/data-setup',
    icon: <GridViewOutlinedIcon />,
    roles: authRoleAccess.dataSetup,
  },
  /*   {
      title: 'Incidents',
      icon: <WarningAmberOutlinedIcon />,
      submenu: [
        {
          title: 'Incidents',
          path: '/incidents',
          roles: authRoleAccess.all_incidents_view,
        },
        {
          title: 'Create Incident',
          path: '/create_incidents',
          roles: authRoleAccess.all_incidents_view,
        }
      ],
  
    }, */

  /* {
    title: 'Documentation',
    path: '/themes/examples',
    icon: <GridViewOutlinedIcon />,
    roles: authRoleAccess.themeExamples,
  }, */

]; 